var _defs, _polygon, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsgov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#333;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "68.55258 66.00491 68.55258 50.29196 64.52328 50.29196 64.52328 66.00491 57.52701 66.00491 57.52701 50.29196 53.49771 50.29196 53.49771 66.00491 46.50143 66.00491 46.50143 50.29196 42.47214 50.29196 42.47214 66.00491 35.47586 66.00491 35.47586 50.29196 31.44656 50.29196 31.44656 66.00491 27.54166 66.00491 25.54166 73.0145 74.45834 73.0145 72.45834 66.00491 68.55258 66.00491"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.41769,42.68887c-.90771-8.80945-8.37219-15.70337-17.41766-15.70337s-16.51074,6.89392-17.41858,15.70337h-7.03979v4.0293h48.91669v-4.0293h-7.04065Zm-24.72406-5.49835c5.25317-5.2533,12.80511-6.25018,16.83417-2.22113,1.96112,1.96118,2.70728,4.75995,2.37305,7.71948h-22.88239c.78448-1.9397,2.01141-3.83466,3.67517-5.49835Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsgov);
export default __webpack_public_path__ + "static/media/icon_usgov.3bf99b583bdf29e7df19bcbf254a90e8.svg";
export { ForwardRef as ReactComponent };